import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from 'react-router-dom';
import { BrowserView, MobileView, isDesktop, isMobile } from 'react-device-detect';
import { ReactSession } from 'react-client-session';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import MuiBottomNavigationAction from "@mui/material/BottomNavigationAction";
import { styled } from "@mui/material/styles";

import RestoreIcon from '@mui/icons-material/Restore';
import FavoriteIcon from '@mui/icons-material/Favorite';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import HomeIcon from '@mui/icons-material/Home';
import DashboardIcon from '@mui/icons-material/Dashboard';
import RoomIcon from '@mui/icons-material/Room';
import InfoIcon from '@mui/icons-material/Info';
import QrCodeIcon from '@mui/icons-material/QrCode';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';

import { LocalizationContext } from '../App';

const LoupeNavigationBar = props => {

    const tabValue = props.tab;        
    const navigate = useNavigate();

   

    return(

        <LocalizationContext.Consumer>
        { ({strings}) => 
            
            <Box sx={{ width: '100vw' }} className="bottomMenu">
                <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
                    <BottomNavigation showLabels={true} value={tabValue} onChange={(event, newValue) => {
                        ReactSession.set("currenttab", newValue);
                        
                        switch(newValue) {
                            
                            case 0:
                                navigate('/', { replace : true });
                                window.scrollTo({
                                    top: 0,
                                    behavior: "smooth"
                                  });
                                break;
                            case 1:
                                navigate('/about', { replace : true });
                                window.scrollTo({
                                    top: 0,
                                    behavior: "smooth"
                                  });
                                break;
                                case 2:
                                navigate('/activities-here', { replace : true });
                                window.scrollTo({
                                    top: 0,
                                    behavior: "smooth"
                                  });
                                break;
                                case 3:
                                navigate('/scan', { replace : true });
                                window.scrollTo({
                                    top: 0,
                                    behavior: "smooth"
                                  });
                                break;
                        }

                        }}>
                       
                        <BottomNavigationAction label={strings.getString("controls.buttons.menu.start")} icon={<HomeIcon />} />
                        <BottomNavigationAction label={strings.getString("controls.buttons.menu.about")} icon={<DashboardIcon />} />
                        <BottomNavigationAction label={strings.getString("controls.buttons.menu.nearby")} icon={<RoomIcon />} />

                        { isMobile == true &&
                            <BottomNavigationAction label={'QR Code'} icon={<QrCodeIcon />} />
                        }
                        
                    </BottomNavigation>
                </Paper>
            </Box>

        }
        </LocalizationContext.Consumer>
    );
}
export default LoupeNavigationBar;